import axios from 'axios';

// API URL MUST be set via environment variable at build time
// This prevents self-referencing and ensures correct routing through web infrastructure
const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  console.error(
    'REACT_APP_API_URL environment variable is not set. ' +
    'Please configure it before running the application.'
  );
}

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,  // Invia cookies automaticamente
});

// NO TOKEN INTERCEPTOR - usa httpOnly cookies
// I cookies vengono inviati automaticamente dal browser
export const shouldRedirectOnUnauthorized = (error) => {
  if (error.response?.status !== 401) {
    return false;
  }

  const requestUrl = error.config?.url || '';
  const isLoginRequest = requestUrl.includes('/auth/login');
  const isAlreadyOnLogin = window.location?.pathname === '/login';

  return !isLoginRequest && !isAlreadyOnLogin;
};

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldRedirectOnUnauthorized(error)) {
      // Cookie scaduto o invalido
      localStorage.removeItem('user');  // Rimuovi solo user info, non token
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
